import { create } from "zustand";

interface UiState {
  sidebarOpen: boolean;
  theme: "light" | "dark" | "system";
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setTheme: (theme: "light" | "dark" | "system") => void;
}



const getInitialSidebarOpen = (): boolean => {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(min-width: 768px)").matches;
}



const getInitialTheme = (): "light" | "dark" | "system" => {
  if (typeof window === "undefined") return "system";
  return (
    (localStorage.getItem("cliently-client-theme") as
      | "light"
      | "dark"
      | "system") || "system"
  );
}



const applyThemeMode = (theme: "light" | "dark" | "system") => {
  const root = document.documentElement;
  root.classList.remove("light", "dark");
  if (theme === "system") {
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)",
    ).matches;
    root.classList.add(prefersDark ? "dark" : "light");
  } else {
    root.classList.add(theme);
  }
}

const initial = getInitialTheme();
if (typeof window !== "undefined") applyThemeMode(initial);

export const useUiStore = create<UiState>((set) => ({
  sidebarOpen: getInitialSidebarOpen(),
  theme: initial,
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
  setTheme: (theme) => {
    localStorage.setItem("cliently-client-theme", theme);
    applyThemeMode(theme);
    set({ theme });
  },
}));
